import { makeStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles({
    label: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 8px',
        fontSize: (props) => (props.fontSize ? `${props.fontSize}px` : '12px'),
        borderRadius: ({ round }) => (round ? '100px' : '4px'),
        fontWeight: 600,
        lineHeight: '15px',
        textTransform: 'uppercase',
        letterSpacing: ({ letterSpacing }) => (letterSpacing ? '1px' : 'normal'),
        backgroundColor: ({ backgroundColor }) => colorPalette[backgroundColor],
        color: ({ color }) => (color ? colorPalette[color] : colorPalette.white),
        marginTop: ({ marginTop }) => (marginTop ? `${marginTop}px` : 0),
        marginBottom: ({ marginBottom }) => (marginBottom ? `${marginBottom}px` : 0),
    },
});
